import useGA from '@/hooks/useGa';
import { GetServerSideProps } from 'next';
import PageCom from '@/page-components/login/Login';
import { MyAES, safeDecodeURIComponent } from '@/utils/aes';
import { safeGetItem } from '@/utils/storage';
import { INVITE_COOPERATION_EMAIL, INVITE_COOPERATION_ID, INVITE_KOL_EMAIL, INVITE_KOL_ID } from '@/page-components/invite/constants';

const getSessionItem = (key: string) => safeGetItem(key, 'session');

// 模块级常量，保证缺省时对象引用稳定，避免下游 refreshDeps/useEffect 反复触发
const EMPTY_QUERY: Record<string, string> = {};

export const comeFrom = ({
  kol_id,
  kol_email,
  f,
  p,
}: {
  kol_id?: string;
  kol_email?: string;
  /**
   * f: from type, ivth: koc 邀请页, hp: 官网, mbox: MagicBox
   */
  f?: string;
  /**
   * p: page
   */
  p?: string;
}) => {
  if (f === 'ivth') {
    // h5
    if (p === 'invite_offers') return '/invite/offers';
    else if (p === 'invite_kol') return '/invite/kol'; // 邀请宣传页，已废弃，由 /invite/offers 替代
    else if (getSessionItem(INVITE_COOPERATION_ID)) return '/invite'; // 邀请合作页
  } else if (f === 'hp') {
    // 官网
    if (!p) return 'homepage_header'; // header
    else if (p === 'home_join-now') return '/home#join-now-btn'; // 首屏 join now 按钮
    else if (p === 'home_work') return '/home#how-dose-work'; // work 模块
    else if (p === 'join_now') return 'homepage_join_now_module'; // join now 模块
    else if (p === 'offers') return '/offers'; // offers 页面，报名弹窗内的超链
  } else if (f === 'mbox') {
    return 'mbox';
  } else if (kol_id && kol_email) {
    return 'email'; // 邮件邀请
  }

  return '';
};

const Login: React.FC<{ query?: Record<string, string> }> = ({ query = EMPTY_QUERY }) => {
  const { utm_ydk, utm_yde, f, p } = query;
  const kol_id = safeDecodeURIComponent(utm_ydk);
  const kol_email = safeDecodeURIComponent(utm_yde);
  const from = comeFrom({ kol_id, kol_email, f, p });
  useGA({
    pageTitle: '登录页',
    params: {
      from,
      kol_id: getSessionItem(INVITE_COOPERATION_ID) || getSessionItem(INVITE_KOL_ID) || (kol_id && MyAES.decrypt(kol_id)),
      kol_email: getSessionItem(INVITE_COOPERATION_EMAIL) || getSessionItem(INVITE_KOL_EMAIL) || (kol_email && MyAES.decrypt(kol_email)),
    },
  });
  return <PageCom query={query} />;
};
export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  return { props: { query } };
};
export default Login;
